import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';
import { SocialNetworks } from './social-networks.model';

export class User extends BaseModel {
  id: number;
  uuid:string;
  username: string;
  password: string;
  email: string;
  accessToken: string;
  refreshToken: string;
  roles: number[];
  pic: string;
  fullname: string;
  occupation: string;
  companyName: string;
  priceStatus:number;
  phone: string;
  address: Address;
  socialNetworks: SocialNetworks;
  country: string;
  distributorCompanyName: string;
  isDirectCustomer: boolean;
  isKikMember: boolean;
  role:string;
  isActive: boolean; // Change type to boolean
  loginLogoutTimestamps: { event: string, timestamp: Date }[];
  profilePicture: string; // Updated field name

  clear(): void {
    this.id = undefined;
    this.uuid='';
    this.username = '';
    this.password = '';
    this.email = '';
    this.roles = [];
    this.fullname = '';
    this.accessToken = 'access-token-' + Math.random();
    this.refreshToken = 'access-token-' + Math.random();
    this.pic = './assets/media/users/default.jpg';
    this.occupation = '';
    this.companyName = '';
    this.phone = '';
    this.priceStatus=undefined;
    this.address = new Address();
    this.address.clear();
    this.socialNetworks = new SocialNetworks();
    this.socialNetworks.clear();
    this.country = '';
    this.distributorCompanyName = '';
    this.isDirectCustomer = false;
    this.isKikMember = false;
    this.role = '';
    this.isActive = false; 
    this.loginLogoutTimestamps = [];
    this.profilePicture = '';
  }   
}
